define( '../src/sublayouts/_helpers/touch-scroller/touch-scroller',[ 'lib/utils', 'iscroll' ],

	function ( utils ) {
		'use strict';

		/**
		 * Adds native feeling scrolling to scrollable content elements
		 * @exports helpers/Scroller
		 * @constructor
		 */
		var Scroller = function () {
			return this;
		};

		/**
		 * Initiate scroller
		 */
		Scroller.prototype.init = function ( $el ) {

			this.$el = $el;

			this.scrollify = utils.isTouchDevice();

			this.$content = this.$el.find( 'div:first-child' );

			if ( this.scrollify ) {
				this.loadScroller();
				this.$el.addClass( 'touch-scroller-wrapper' );
				this.$content.addClass( 'touch-scroller-content' );
			} else {
				this.$el.addClass( 'touch-scroller-overflow' );
			}

		};

		Scroller.prototype.loadScroller = function () {

			var scroller = new IScroll( this.$el[ 0 ], {

				mouseWheel: true,
				disableMouse: false,
				scrollX: false,
				scrollY: true,
				momentum: true,
				snap: false,
				keyBindings: true,
				click: true,
				tap: true
			} );

			this.iscroll = scroller;
			this.refresh();

		};

		Scroller.prototype.refresh = function () {

			if ( this.scrollify ) {
				this.iscroll.refresh();
			}

		};

		return Scroller;

	} );

